<template>
  <div
    class="webhook-options-modal"
    data-cy="webhooks-options"
    @click.stop.prevent
  >
    <div class="border-b border-gray-100 p-4">
      <search-input
        :value="filters.search"
        no-margin
        no-padding
        @click.stop="
          (event: Event) => (event.target as HTMLInputElement)?.focus()
        "
        @update:model-value="$emit('search:update', $event)"
      />
    </div>
    <div>
      <loader :is-loading="triggering" />
      <ul class="max-h-[327px] overflow-auto p-2" @scroll="handleScroll">
        <trigger-webhooks-menu-item
          v-for="webhook in webhooks"
          :key="webhook.id"
          :webhook="webhook"
          :checked-items="checkedItems"
          :show-tooltip="showTooltip"
          @webhook:toggle="emit('webhook:toggle', webhook.id)"
          @parameter:change="emit('parameter:change', webhook.id, $event)"
        />
      </ul>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";

import Loader from "@/components/ui/Loader.vue";
import SearchInput from "@/components/ui/inputs/SearchInput.vue";
import TriggerWebhooksMenuItem from "@/views/deals/components/controlPanel/TriggerWebhooksMenuItem.vue";

import type { TemplateViewParams } from "@/models/clients";
import type { CustomWebhook } from "@/models/customWebhook";
import type { OptionalWorkflowWebhookParameter } from "@/models/workflows";

const emit = defineEmits<{
  "search:update": [string];
  "webhook:toggle": [number | string];
  "parameter:change": [number | string, OptionalWorkflowWebhookParameter[]];
}>();

const { webhooks } = defineProps<{
  webhooks: CustomWebhook[];
  filters: TemplateViewParams;
  checkedItems: number[];
  triggering: boolean;
}>();

const showTooltip = ref(true);

const handleScroll = () => {
  // Hide tooltip when scrolling
  showTooltip.value = false;
  showTooltip.value = true;
};
</script>

<style scoped>
@reference "@/assets/tailwind.css";

.webhook-options-modal {
  @apply absolute z-100 max-h-100 min-h-30 max-w-145 min-w-80 rounded bg-white shadow-lg transition-all;
}
</style>
